/**
 * tf-components — Bundle aggregato Web Components condivisi.
 *
 * Caricato come `<script type="module">` nelle pagine che usano i custom element.
 * Auto-registra i 4 elements: <tf-modal>, <tf-skeleton>, <tf-topbar>, <tf-sidebar>.
 *
 * @since v9.16 (Sprint 3)
 */

// Auto-register via side effects (i moduli si registrano quando importati)
import { TfModalElement } from './components/tf-modal';
import { TfSkeletonElement, skelRace } from './components/tf-skeleton';
import { TfTopbarElement } from './components/tf-topbar';
import { TfSidebarElement } from './components/tf-sidebar';
import { TfSidebarV2Element } from './components/tf-sidebar-v2';
import { TfSearchElement } from './components/tf-search';
// Sprint 9 form components
import { TfInputElement } from './components/tf-input';
import { TfButtonElement } from './components/tf-button';
import { TfCardElement } from './components/tf-card';

// Re-export classi per import esplicito (es. test)
export {
  TfModalElement,
  TfSkeletonElement,
  TfTopbarElement,
  TfSidebarElement,
  TfSidebarV2Element,
  TfSearchElement,
  TfInputElement,
  TfButtonElement,
  TfCardElement,
  skelRace,
};

// Esponi helpers come window globals
declare global {
  interface Window {
    tfComponents?: {
      version: string;
      skelRace: typeof skelRace;
      classes: {
        TfModalElement: typeof TfModalElement;
        TfSkeletonElement: typeof TfSkeletonElement;
        TfTopbarElement: typeof TfTopbarElement;
        TfSidebarElement: typeof TfSidebarElement;
        TfSidebarV2Element: typeof TfSidebarV2Element;
        TfSearchElement: typeof TfSearchElement;
        TfInputElement: typeof TfInputElement;
        TfButtonElement: typeof TfButtonElement;
        TfCardElement: typeof TfCardElement;
      };
    };
  }
}

if (typeof window !== 'undefined') {
  window.tfComponents = {
    version: '9.16.0',
    skelRace,
    classes: {
      TfModalElement,
      TfSkeletonElement,
      TfTopbarElement,
      TfSidebarElement,
      TfSidebarV2Element,
      TfSearchElement,
      TfInputElement,
      TfButtonElement,
      TfCardElement,
    },
  };
}
